module.exports = __webpack_public_path__ + "static/images/icon-warner-bros.4592929085ef540587f74a8d55149ea8.svg";